/**
 * Centralized API configuration.
 * All API calls should use this base URL instead of hardcoding paths.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";

/**
 * Builds a full API URL from a path.
 * @param path - The API path (e.g., "/api/pools", "/api/orders")
 * @returns The full URL (e.g., "https://api.sportex100.com/api/pools")
 */
export function apiUrl(path: string): string {
  // Ensure path starts with /
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}
